import { render, staticRenderFns } from "./RomaDonePoll.vue?vue&type=template&id=420bde1a&scoped=true&"
import script from "./RomaDonePoll.vue?vue&type=script&lang=js&"
export * from "./RomaDonePoll.vue?vue&type=script&lang=js&"
import style0 from "./RomaDonePoll.vue?vue&type=style&index=0&id=420bde1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420bde1a",
  null
  
)

export default component.exports